import { MARKET_DATA_DEMO } from './marketDataDemoContent';

// Script of the coded product tour on Home (replaces julkisethankinnat4.mp4, which was Finnish only and silent).
// Market data comes from the market data demo. The notices are real: FI/EN show the Senaatti-kiinteistöt tender
// and the search hits of the recorded video (published 24.–26.3.2026), SE shows Karolinska Universitetssjukhuset's
// "AI Tal-till-text" (E-avrop K 2026-8642, published 2026-10-18) with its seven attachments and the hits of a
// Swedish "AI" search (checked 23.10.2026). Change them only against the source.

const fiNotice = {
    scope: 'EU',
    title: 'Senaatti-kiinteistöt: Senaatin verkkosivut ja mobiilisovellus',
    meta: ['Kilpailullinen neuvottelumenettely', 'Senaatti-kiinteistöt', 'Julkaistu 26.3.2026'],
    deadline: 'Määräaika 28.4.2026 12:00',
    attachments: [
        'procurement-espd.pdf',
        'procurement.pdf',
        'Liite_01_Turvallisuusselvityksen_yhteyshenkilö.docx',
        'Liite_03_Tietoaineistojen_käsittelyohje_palveluntuottajille.pdf',
        'Liite_07_Alihankintamatriisi.pdf',
        'Liite_1_Hankinnan_kohteen_kuvaus.pdf',
        'Liite_2_Pisteytettävät_referenssit.xlsx',
    ],
};

export const HERO_DEMO = {
    fi: {
        market: MARKET_DATA_DEMO.fi,
        nav: { search: 'Haku' },
        search: {
            title: 'Haku',
            label: 'Hakusanat',
            keyword: 'tekoäly',
            button: 'Hae',
            columns: ['Laajuus', 'Tyyppi', 'Otsikko', 'Ostaja', 'Julkaistu', 'Määräaika'],
            rows: [
                ['EU', 'Hankintailmoitus', 'Senaatti-kiinteistöt: Senaatin verkkosivut ja mobiilisovellus', 'Senaatti-kiinteistöt', '26.3.2026', '28.4.2026'],
                ['FI', 'Ennakkotietoilmoitus', 'Kutsu markkinavuoropuheluun: asiakaskokemuksen mittaamisen palvelu', '–', '25.3.2026', '15.4.2026'],
                ['FI', 'Ennakkotietoilmoitus', 'Tietopyyntö: Tulkkauspalveluiden hankinta', '–', '25.3.2026', '1.4.2026'],
                ['EU', 'Ennakkotietoilmoitus', 'HUS Diagnostiikkakeskuksen Siemens MR-laitepäivitykset 2026–2027', 'HUS-yhtymä', '24.3.2026', '–'],
            ],
            description: 'Senaatti-kiinteistöt pyytää ehdokkaita lähettämään osallistumishakemuksen neuvottelumenettelyyn. Hankinnan ennakoitu arvo sopimuskaudella on 4 000 000 euroa. Sopimus kestää 4 vuotta, jonka jälkeen se jatkuu toistaiseksi.',
            open: 'Avaa ilmoitus',
        },
        notice: {
            ...fiNotice,
            ask: 'Kysy tekoälyltä',
            tabs: ['Yhteenveto', 'Osat', 'Ostajan tiedot', 'Määräajat', 'Liitteet'],
            attachmentsTitle: 'Liitteet',
            view: 'Avaa',
            download: 'Lataa',
        },
        chat: {
            title: 'Kysy tästä tarjouspyynnöstä',
            subtitle: fiNotice.title,
            placeholder: 'Kysy tarjouspyynnöstä…',
            question: 'Tee yhteenveto tarjouspyynnöstä',
            summaryTitle: 'Yhteenveto',
            summary: 'Senaatti-kiinteistöt kilpailuttaa verkkosivujensa ja mobiilisovelluksensa kehitys- ja ylläpitopalvelut neuvottelumenettelyllä. Ennakoitu arvo on 4 000 000 euroa.',
            datesTitle: 'Keskeiset päivämäärät',
            dates: [['Ilmoitus julkaistu', '26.3.2026'], ['Kysymysten määräaika', '15.4.2026 klo 12'], ['Osallistumishakemukset', '28.4.2026 klo 12']],
            criteriaTitle: 'Valinta ja vertailu',
            criteria: ['Neuvotteluun valitaan 5 ehdokasta referenssien perusteella', 'Hinta 50–80 %, laatu 20–50 %'],
            source: 'liite',
        },
        endLines: ['Kaikki julkiset hankinnat yhdessä paikassa.', 'Näe tulevat hankkeet ennen kilpailutusta.', 'Tekoäly lukee tarjouspyynnöt puolestasi.'],
        chapters: ['Markkinadata', 'Hankkeet', 'Haku', 'Liitteet', 'Kysy tekoälyltä', 'Tendera'],
    },
    en: {
        market: MARKET_DATA_DEMO.en,
        nav: { search: 'Search' },
        search: {
            title: 'Search',
            label: 'Keywords',
            keyword: 'tekoäly',
            button: 'Search',
            columns: ['Scope', 'Type', 'Title', 'Buyer', 'Published', 'Deadline'],
            rows: [
                ['EU', 'Contract notice', 'Senaatti-kiinteistöt: Senaatti website and mobile app', 'Senaatti-kiinteistöt', '26 Mar 2026', '28 Apr 2026'],
                ['FI', 'Prior information', 'Market dialogue: customer experience measurement service', '–', '25 Mar 2026', '15 Apr 2026'],
                ['FI', 'Prior information', 'Request for information: interpreting services', '–', '25 Mar 2026', '1 Apr 2026'],
                ['EU', 'Prior information', 'HUS Diagnostic Centre Siemens MR upgrades 2026–2027', 'HUS Group', '24 Mar 2026', '–'],
            ],
            description: 'Senaatti-kiinteistöt invites candidates to apply for a negotiated procedure. The estimated value over the contract period is €4,000,000. The contract runs for 4 years and then continues until further notice.',
            open: 'Open notice',
        },
        notice: {
            ...fiNotice,
            title: 'Senaatti-kiinteistöt: Senaatti website and mobile app',
            meta: ['Competitive negotiated procedure', 'Senaatti-kiinteistöt', 'Published 26 Mar 2026'],
            deadline: 'Deadline 28 Apr 2026 12:00',
            ask: 'Ask AI',
            tabs: ['Summary', 'Lots', 'Buyer Information', 'Deadlines', 'Attachments'],
            attachmentsTitle: 'Attachments',
            view: 'View',
            download: 'Download',
        },
        chat: {
            title: 'Ask about this tender',
            subtitle: 'Senaatti-kiinteistöt: Senaatti website and mobile app',
            placeholder: 'Ask about the tender…',
            question: 'Summarise this tender',
            summaryTitle: 'Summary',
            summary: 'Senaatti-kiinteistöt is tendering the development and maintenance of its website and mobile app in a negotiated procedure. The estimated value is €4,000,000.',
            datesTitle: 'Key dates',
            dates: [['Notice published', '26 Mar 2026'], ['Questions deadline', '15 Apr 2026 at 12'], ['Requests to participate', '28 Apr 2026 at 12']],
            criteriaTitle: 'Selection and award',
            criteria: ['5 candidates are invited to negotiate, based on references', 'Price 50–80%, quality 20–50%'],
            source: 'attachment',
        },
        endLines: ['All public procurement in one place.', 'See upcoming projects before they are tendered.', 'AI reads the tender documents for you.'],
        chapters: ['Market data', 'Projects', 'Search', 'Attachments', 'Ask AI', 'Tendera'],
    },
    sv: {
        market: MARKET_DATA_DEMO.sv,
        nav: { search: 'Sök' },
        search: {
            title: 'Sök',
            label: 'Sökord',
            keyword: 'AI',
            button: 'Sök',
            columns: ['Omfång', 'Typ', 'Rubrik', 'Köpare', 'Publicerad', 'Sista dag'],
            rows: [
                ['SE', 'Upphandlingsannons', 'AI Tal-till-text', 'Karolinska Universitetssjukhuset', '2026-10-18', '2026-11-19'],
                ['SE', 'Upphandlingsannons', 'AeroCore FIDS', 'Swedavia AB', '2026-10-21', '2026-11-15'],
                ['SE', 'Upphandlingsannons', 'RFI – Kamerabevakning – marknadsanalys innan upphandling', 'Stockholms stad', '2026-10-19', '2026-11-01'],
            ],
            description: 'Upphandlingen avser AI-baserade tal-till-text-lösningar för klinisk dokumentation inom den egenägda vården i Region Stockholm och Region Gotland, exempelvis så kallad ambient scribe.',
            open: 'Öppna annonsen',
        },
        notice: {
            scope: 'SE',
            title: 'AI Tal-till-text',
            meta: ['Konkurrenspräglad dialog', 'Karolinska Universitetssjukhuset', 'Publicerad 2026-10-18'],
            deadline: 'Sista dag 2026-11-19 23:59',
            ask: 'Fråga AI',
            tabs: ['Sammanfattning', 'Delkontrakt', 'Köparinformation', 'Tidsfrister', 'Bilagor'],
            attachmentsTitle: 'Bilagor',
            view: 'Visa',
            download: 'Ladda ner',
            attachments: [
                'Ansökningsinbjudan',
                'Krav på leverantören',
                'Bilaga Sanningsförsäkran.docx',
                'Bilaga Mall för personuppgiftsbiträdesavtal.docx',
                'Bilaga Uppförandekod för leverantörer.pdf',
                'Bilaga Tillbörlig aktsamhet för hållbara leveranskedjor.pdf',
                'Bilaga Intygande med anledning av EU-sanktioner.docx',
            ],
        },
        chat: {
            title: 'Fråga om denna upphandling',
            subtitle: 'AI Tal-till-text',
            placeholder: 'Fråga om upphandlingen…',
            question: 'Sammanfatta upphandlingen',
            summaryTitle: 'Sammanfattning',
            summary: 'Karolinska Universitetssjukhuset upphandlar AI-baserade tal-till-text-lösningar för klinisk dokumentation i Region Stockholm och Region Gotland. Uppskattat värde 95 mnkr.',
            datesTitle: 'Viktiga datum',
            dates: [['Publicerad', '2026-10-18'], ['Sista dag för frågor', '2026-11-08'], ['Sista ansökningsdag', '2026-11-19 kl. 23.59'], ['Beräknad avtalsperiod', '2026-11-30 – 2028-11-29']],
            criteriaTitle: 'Upphandlingen',
            criteria: ['Konkurrenspräglad dialog som leder till ramavtal med flera leverantörer', 'Tidsbegränsade piloter planeras under dialogen'],
            source: 'annons',
        },
        endLines: ['Alla offentliga upphandlingar på ett ställe.', 'Se kommande projekt innan de upphandlas.', 'AI läser förfrågningsunderlagen åt dig.'],
        chapters: ['Marknadsdata', 'Projekt', 'Sök', 'Bilagor', 'Fråga AI', 'Tendera'],
    },
};

export const heroDemoContent = (language) => HERO_DEMO[String(language || '').split('-')[0]] || HERO_DEMO.en;
